module.exports = __webpack_public_path__ + "static/media/firefox-android-2.bab58039.png";